module.exports = __webpack_public_path__ + "img/struc-rebar-anchorage.3541bd0e.png";